export default __webpack_public_path__ + "static/media/hacksaw.66411380.svg";